import Flickity from "flickity-fade"

export default class BaseCarouselWithFullWidthSlides {
    sliderContainer = null;
    slider = null;
    slides = null;
    currentSlide = 0;
    preview = false;
    autoplay = 0;
    transition = 'slide';

    constructor(preview, autoplay, transition) {
        this.preview = preview;
        this.autoplay = autoplay;
        this.transition = transition;
    }

    init() {
        const container = this.$el.querySelector('.Slide__Container');
        this.sliderContainer = container.querySelector('.slider');

        if(!this.preview){
            this.initSlider();
            this.updateTabIndexes(this.slides);
    
            pegasus.onResizeFinished(() => {
                this.sliderResize();
            }, true);

        }
    }

    initSlider() {
        if(this.slider !== null){
            this.slider.destroy();
        }

        let options = {
            cellAlign: "left",
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            pauseAutoPlayOnHover: false,
            on: {
                settle: () => {
                    this.updateTabIndexes(this.slides);
                },
                change: () => {
                    this.currentSlide = this.slider.selectedIndex;
                },
            },
        };

        if(this.autoplay > 0){
            options.autoPlay = (this.autoplay * 1000);
        }

        if(this.transition === 'fade'){
            options.fade = true;
        }
    

        this.slider = new Flickity(this.sliderContainer, options);

        this.slides = this.sliderContainer.querySelectorAll('[data-pegasus-slide');

    }

    resetAutoplay() {
        if (!this.preview && this.autoplay > 0) {
            this.slider.pausePlayer();
            this.slider.unpausePlayer();
        }
    }

    nextSlide(){
        if(this.preview) {
            const slider = this.$root.querySelector('.slider');

            // scroll to the next slide
            slider.scrollLeft += slider.offsetWidth;
        } else {
            this.slider.next();
            this.resetAutoplay();
        }

    }

    previousSlide(){
        if(this.preview) {
            const slider = this.$root.querySelector('.slider');

            // scroll to the previous slide
            slider.scrollLeft -= slider.offsetWidth;
        } else {
            this.slider.previous();
            this.resetAutoplay();
        }

    }

    /**
     * sliderResize
     * 
     * @return void
     */
    sliderResize() {

        if(this.sliderContainer === null) return;

        const flickitySliders = this.sliderContainer.querySelectorAll('.flickity-slider');

        this.sliderFullWidth = 0;

        flickitySliders.forEach(slider => {
            let height = 0;

            this.slides.forEach(slide => {
                slide.style.height = '';
                if(slide.offsetHeight > height){
                    height = slide.offsetHeight;
                }
            });

            this.slides.forEach(slide => {
                slide.style.height = height+'px';
            })

            slider.style.height = '';
            slider.style.height = height+'px';


        });

    }

    /**
     * updateTabIndexes
     *
     * Description: Updates the tabindexes of the slides this is required for accessibility.
     * Inactive slides shouldn't be accessible via the keyboard.
     *
     * @param {} slides
     * @return void
     */
    updateTabIndexes(slides) {
        slides.forEach((slide) => {
            const slideElements = slide.querySelectorAll("a, button");

            slideElements.forEach((element) => {
                if (slide.classList.contains("is-selected")) {
                    element.removeAttribute("tabindex");
                } else {
                    element.setAttribute("tabindex", "-1");
                }
            });
        });
    };


}

document.addEventListener('alpine:init', () => {
    Alpine.data('carouselWithFullWidthSlides', (preview, autoplay, transition) => new BaseCarouselWithFullWidthSlides(preview, autoplay, transition));
});
